var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"workplace"},[_c('a-card',{staticClass:"workplace-stat-card",attrs:{"bordered":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }